/*--------------------------------------------------------------------------------------*/

export const SMCStyleMenuItem = {
	fontSize: '13px',
	fontWeight: 'normal',
	whiteSpace: 'pre',
	minHeight: '29px',
	padding: '2px 5px 2px 31px',
	display: 'flex',
}

export const SMCStyleMenuTitle = {
	paddingLeft: '10px',
	fontSize: '13px',
	fontWeight: 'bold',
	whiteSpace: 'pre',
	minHeight: '28px',
	height: '28px',
	padding: '5px 10px 5px',
	display: 'flex',
}

export const SMCStyleMenuSelected = {
    backgroundColor: '#BCE3FE'
}